module.exports = __webpack_public_path__ + "static/media/groceryListIcon4.0dc89968.svg";